
import { setErrorDialog, serverUrl, getheader} from "../../../store/api/CommonFunctions";

export const nationalUrl = serverUrl + "api/CustomersAPI/SearchNationalCode";
export function addNewCustomer(data, fn) {
  const _header = getheader();
  data.RegisteredFromSite = false;
  let customer = data;
  data = JSON.stringify(data)
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })

    fetch(serverUrl + "api/CustomersAPI/AddCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message || res === "ErrorMobile" || res === "ErrorPhone" || res === "ErrorNationalCode") {
          const msg = res.Message ?? res;
          setErrorDialog(dispatch, msg, "مشتری جدید");
          return;
        }

        customer.ID = Number(res);
        fn(customer);
        setErrorDialog(dispatch, "success", "ایجاد مشتری جدید");
      }).catch(err => {
        console.error('[ADD_CUSTOMER]', err);
        alert("اشکال در انجام عملیات");
      });
  }
}
export function editCustomerInfo(data, fn) {
  const _header = getheader();
  data.RegisteredFromSite = true;
  const editedInfo = data;
  data = JSON.stringify(data)
  return dispatch => {

    fetch(serverUrl + "api/CustomersAPI/EditCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message || res === "ErrorMobile" || res === "ErrorPhone" || res === "ErrorNationalCode") {
          const msg = res.Message ?? res;
          setErrorDialog(dispatch, msg, "ویرایش اطلاعات مشتری");
          return;
        }
        setErrorDialog(dispatch, "success", "ویرایش اطلاعات مشتری");
        fn();
        dispatch({
          type: "FETCH_CURRENT_CUSTOMER",
          data: editedInfo
        });
      }).catch(err => {
        console.error('[Edit_CUSTOMER]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  }
}
export function setCustomerEmpty() {
  return dispatch => {
    dispatch({
      type: "FETCH_CUSTOMER",
      data: undefined
    });
  }
}
export function getCutomerByID(id) {
  const _header = getheader();
  return dispatch => {
    dispatch({
      type: "FETCH_CUSTOMER",
      data: "PENDING"
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerByID?Id=" + id, {
      headers: _header,
      method: "GET"
    }).then(resp => resp.json())
      .then(resp => {
        if (resp.Message) {
          setErrorDialog(dispatch, resp.Message, "دریافت اطلاعات مشتری");
          resp = null;
        }
        return dispatch({
          type: "FETCH_CUSTOMER",
          data: resp
        })
      }).catch(err => {
        console.log("[FETCH_CURRENT_CUSTOMER]", err);
      })
  }
}
export function setNewPassword(data, fn) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    //let mobile = data.StringValue;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/SetNewPassword", {
      headers: getheader(),
      body: data,
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (resp === "Success") {
          localStorage.removeItem('token');
          alert("عملیات با موفقیت انجام شد. از نرم افزار خارج شده و دوباره وارد شوید");
        }
        else if (resp.Message === "Error") {
          alert("اشکال در انجام عملیات");
        }
        else if (resp.Message === "NotFound") {
          alert("کاربری با این مشخصات در سیستم وجود ندارد");
        }
        else if (resp.Message === "IsBlackListed") {
          alert("این کاربری در لیست سیاه قرار دارد");
        }
        else if (resp.Message === "IsNotActive") {
          alert("این کاربری فعال نیست");
        }
        if (fn !== undefined) {
          fn();
        }
      }).catch(e => {
        dispatch({
          type: "LOADING",
          data: false
        });
        console.log("[REQUEST_PASS]", e);
        alert("اشکال در انجام عملیات");
      })
  }
}
export function forgetPassword(data, fn) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    let mobile = data.StringValue;
    data.ID = 0;
    data.Value = 0;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/ForgetPassword", {
      headers: {
        // 'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'credentials': 'include'
      },
      body: data,
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (resp === "Success") {
          localStorage.removeItem('token');
          alert(`رمز جدید به شماره موبایل ${mobile} ارسال شد`);
        }
        else if (resp.Message === "Error") {
          alert("اشکال در انجام عملیات");
        }
        else if (resp.Message === "NotFound") {
          alert("کاربری با این مشخصات در سیستم وجود ندارد");
        }
        else if (resp.Message === "IsBlackListed") {
          alert("این کاربری در لیست سیاه قرار دارد");
        }
        else if (resp.Message === "IsNotActive") {
          alert("این کاربری فعال نیست");
        }
        if (fn !== undefined) {
          fn();
        }
      }).catch(e => {
        dispatch({
          type: "LOADING",
          data: false
        });
        console.log("[REQUEST_PASS]", e);
        alert("اشکال در انجام عملیات");
      })
  }
}
export function setCustomerPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_CUSTOMER_POPUP",
      data: status
    });
  }
}
export function searchCustomer(data) {
  return dispatch => {
    dispatch({
      type: "SEARCH_CUSTOMER",
      data: "PENDING"
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerByFilter", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "SEARCH_CUSTOMER",
          data: res
        })
      }).catch(e => console.log("SEARCH_CUSTOMER", e));
  }
}
export function checkNationalCode(NationalCode) {
  if (NationalCode.length === 10) {
    if (NationalCode === '1111111111' ||
      NationalCode === '0000000000' ||
      NationalCode === '2222222222' ||
      NationalCode === '3333333333' ||
      NationalCode === '4444444444' ||
      NationalCode === '5555555555' ||
      NationalCode === '6666666666' ||
      NationalCode === '7777777777' ||
      NationalCode === '8888888888' ||
      NationalCode === '9999999999') {
      return false;
    }
    let c = parseInt(NationalCode.charAt(9));
    let n = parseInt(NationalCode.charAt(0)) * 10 +
      parseInt(NationalCode.charAt(1)) * 9 +
      parseInt(NationalCode.charAt(2)) * 8 +
      parseInt(NationalCode.charAt(3)) * 7 +
      parseInt(NationalCode.charAt(4)) * 6 +
      parseInt(NationalCode.charAt(5)) * 5 +
      parseInt(NationalCode.charAt(6)) * 4 +
      parseInt(NationalCode.charAt(7)) * 3 +
      parseInt(NationalCode.charAt(8)) * 2;
    let r = n - parseInt(n / 11) * 11;
    if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
      return false;
    }
    else {
      return true;
    }
  }
  else {
    return false;
  }

}
export function getCustomerBaseInfoes() {
  return dispatch => {
    dispatch({
      type: "CUSTOMER_BASE_INFO",
      data: "PENDING"
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerBaseInfoes", {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت اطلاعات");
          res = null;
        }
        dispatch({
          type: "CUSTOMER_BASE_INFO",
          data: res
        });
      }).catch(e => {
        console.log("[CUSTOMER_BASE_INFO]", e);
        dispatch({
          type: "CUSTOMER_BASE_INFO",
          data: null
        });
      })
  }
}
export function getLastCustomerCode(fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/GetLastCustomerCode", {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (Number(res) > 0) {
          fn(res);
        }
      })
  }
}
export function deleteCustomer(id, fn) {
  const data = {customerID: id};
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeleteCustomer", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(id)
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "حذف مشتری");
        if (res.Result) {
          fn();
        }
      })
  }
}
